import React, { useState, useEffect } from 'react';
import { Calendar, Users, CheckCircle2, Truck, Clock, ArrowRight } from 'lucide-react';
import './timeline.css'; // Importar estilos CSS
import { Crud_Catalogos, Crud_error } from "../../herramientas/Crud_Catalogos";
import { setDate } from 'date-fns';

const TimelineComponent = (props) => {

    console.log(props)
    const [data, setData] = useState(null);

      useEffect(() => {
        
         
        Crud_Catalogos(
                "navieraMovimientos/obtenerLineTime/" + props.movimiento.id,
                "",
                "get",
                props.movimiento.id,
                )
                .then((returnVal) => {
                
                console.log("lineTIME",returnVal)

                let fechaCita = ""; 
                let horaCita  = "";
                if(returnVal.fechaCita && returnVal.fechaCita != ''){
                  fechaCita = returnVal.fechaCita.split(" ")[0];
                  horaCita = returnVal.fechaCita.split(" ")[1];
                }

                let fechaLlegada = ""; 
                let horaLlegada  = "";
                if(returnVal.fechaLlegadaCita && returnVal.fechaLlegadaCita != ''){
                   fechaLlegada = returnVal.fechaLlegadaCita.split(" ")[0];
                   horaLlegada = returnVal.fechaLlegadaCita.split(" ")[1];
                }

                let fechaAsignacion  ="";
                let horaAsignacion   = "";

                if(returnVal.fechaAsignacion && returnVal.fechaAsignacion != ''){
                      fechaAsignacion = returnVal.fechaAsignacion.split(" ")[0];
                      horaAsignacion  = returnVal.fechaAsignacion.split(" ")[1];
                }


                let fechaPatio  ="";
                let horaPatio   = "";

                if(returnVal.fechaEnPatio && returnVal.fechaEnPatio != '' ){
                      fechaPatio = returnVal.fechaEnPatio.split(" ")[0];
                      horaPatio  = returnVal.fechaEnPatio.split(" ")[1];
                }


              let fechaColocacion  ="";
              let horaColocacion   = "";

              if(returnVal.fechaColocacion && returnVal.fechaColocacion != ""){
                fechaColocacion = returnVal.fechaColocacion.split(" ")[0];
                horaColocacion  = returnVal.fechaColocacion.split(" ")[1];
              }
              


              const datosMov = {
                llegadaCliente:    { fecha: fechaLlegada,     hora:horaLlegada     },
                citaProgramada:    { fecha: fechaCita, hora: horaCita       },
                fechaAsignacion:   { fecha: fechaAsignacion,  hora: horaAsignacion },
                confirmacionPatio: { fecha: fechaPatio, hora: horaPatio            },
                fechaColocacion:   { fecha: fechaColocacion,  hora: horaColocacion }
              };

              setData(datosMov);
              
        });
  
  }, []);




  if(!data){
    return <div>Cargando...</div>
  }
 


  const timelineItems = [
   
    {
      id: 1,
      title: 'Fecha Asignación',
      date: data.fechaAsignacion?.fecha,
      time: data.fechaAsignacion?.hora,
      icon: Users,
      color: 'blue'
    },
    {
      id: 2,
      title: 'Confirmación Patio',
      date: data.confirmacionPatio?.fecha,
      time: data.confirmacionPatio?.hora,
      icon: CheckCircle2,
      color: 'orange'
    },
    {
      id: 3,
      title: 'Fecha Colocación',
      date: data.fechaColocacion?.fecha,
      time: data.fechaColocacion?.hora,
      icon: Truck,
      color: 'purple'
    },
     {
      id: 4,
      title: 'Cita Programada',
      date: data.citaProgramada?.fecha,
      time: data.citaProgramada?.hora,
      icon: Calendar,
      color: 'emerald'
    }
    ,
    {
      id: 5,
      title: 'Llegada en cliente',
      date: data.llegadaCliente?.fecha,
      time: data.llegadaCliente?.hora,
      icon: Calendar,
      color: 'emerald'
    }
  ];

  const formatDate = (dateString) => {
  if (!dateString) {
    return { 
      day: '--', 
      month: 'TBD', 
      year: '--',
      formatted: 'Por definir' 
    };
  }
  
  // Si es formato YYYY-MM-DD, agregar tiempo para evitar problemas de zona horaria
  const dateToUse = dateString.includes('T') ? dateString : `${dateString}T12:00:00`;
  const date = new Date(dateToUse);
  
  return {
    day: date.getDate().toString().padStart(2, '0'),
    month: date.toLocaleDateString('es-MX', { month: 'short' }),
    year: date.getFullYear().toString(),
    formatted: date.toLocaleDateString('es-MX', { 
      day: 'numeric', 
      month: 'short',
      year: 'numeric'
    })
  };
};


  const completedItems = timelineItems.filter(item => item.date && item.time && item.id != 4).length;

  console.log(completedItems)
  const progressPercentage = (completedItems / (timelineItems.length - 1)) * 100;

  const getCircleClass = (color, isCompleted) => {
    if (!isCompleted) return 'timeline-circle pending';
    return `timeline-circle completed-${color}`;
  };

  const getDateContainerClass = (color, isCompleted) => {
    if (!isCompleted) return 'timeline-date-container pending';
    return `timeline-date-container completed-${color}`;
  };

  const getTimeContainerClass = (color, isCompleted) => {
    if (!isCompleted) return 'timeline-time-container pending';
    return `timeline-time-container completed-${color}`;
  };

  const calculateTimeDifference = (startItem, endItem) => {
    if (!startItem.date || !startItem.time || !endItem.date || !endItem.time) {
      return null;
    }
    
    const startDateTime = new Date(`${startItem.date} ${startItem.time}`);
    const endDateTime = new Date(`${endItem.date} ${endItem.time}`);
    
    const diffMs = endDateTime - startDateTime;
    const diffHours = Math.abs(diffMs / (1000 * 60 * 60));
    const diffDays = Math.floor(diffHours / 24);
    const remainingHours = Math.floor(diffHours % 24);
    
    if (diffDays > 0) {
      return `${diffDays}d ${remainingHours}h`;
    } else {
      return `${remainingHours}h`;
    }
  };

  return (
    <div className="horizontal-timeline-container">
      {/* Header */}
      <div className="timeline-header">
        <h1 className="timeline-title">
          Timeline del Servicio
        </h1>
        
        {/* Barra de progreso global */}
        {/* <div className="progress-container">
          <div className="progress-labels">
            <span>Progreso: {completedItems}/{timelineItems.length}</span>
            <span>{Math.round(progressPercentage)}% completado</span>
          </div>
          <div className="progress-bar">
            <div 
              className="progress-fill"
              style={{ width: `${progressPercentage}%` }}
            ></div>
          </div>
        </div> */}
      </div>

      {/* Timeline Horizontal Scrolleable */}
      <div className="timeline-scroll-container">
        <div className="timeline-flex-container">
          {timelineItems.map((item, index) => {

            if(item.title == 'Llegada en cliente'){
              return;
            }


            const Icon = item.icon;
            const dateInfo = formatDate(item.date);
            if(item.title == 'Cita Programada'){
              item.date = data.llegadaCliente?.fecha 
            }
            
            console.log(item.time)

            let isCompleted = !!(item.date && item.time );
            
           
            const isLast = index === timelineItems.length - 2;
            const nextItemCompleted = index < timelineItems.length - 1 && 
              timelineItems[index + 1].date && timelineItems[index + 1].time;
            
            return (
              <React.Fragment key={item.id}>
                {/* Elemento del Timeline */}
                <div className="timeline-item">
                  {/* Círculo superior */}
                  <div className={getCircleClass(item.color, isCompleted)}>
                    <Icon className="timeline-circle-icon" />
                    
                    {/* Badge de estado */}
                    <div className={`timeline-status-badge ${isCompleted ? 'completed' : 'pending'}`}>
                      {isCompleted && <CheckCircle2 className="timeline-status-badge-icon" />}
                    </div>
                  </div>

                  {/* Tarjeta horizontal */}
                  <div className={`timeline-card ${isCompleted ? 'completed' : 'pending'}`}>
                    {/* Título */}
                    <h3 className="timeline-card-title">
                      {item.title}
                    </h3>
                    
                    {/* Información en dos columnas */}
                    <div className="timeline-info-grid">
                      {/* Fecha */}
                      <div className="timeline-info-section">
                        <div className="timeline-info-label">
                          <Calendar className={`timeline-info-label-icon ${isCompleted ? 'completed' : 'pending'}`} />
                          <span className="timeline-info-label-text">Fecha</span>
                        </div>
                        <div className={getDateContainerClass(item.color, isCompleted)}>
                          <div className="timeline-date-day">{dateInfo.day}</div>
                          <div className="timeline-date-month">{dateInfo.month}</div>
                          <div className="timeline-date-year">{dateInfo.year}</div>
                        </div>
                      </div>
                      
                      {/* Hora */}
                      <div className="timeline-info-section">
                        <div className="timeline-info-label">
                          <Clock className={`timeline-info-label-icon ${isCompleted ? 'completed' : 'pending'}`} />
                          <span className="timeline-info-label-text">Hora</span>
                        </div>
                        <div className={getTimeContainerClass(item.color, isCompleted)}>
                          {item.time || '--:--'}
                        </div>
                      </div>
                    </div>
                    
                    {/* Estado */}
                    <div className="timeline-card-status">
                      <span className={`timeline-status-label ${isCompleted ? 'completed' : 'pending'}`}>
                        {isCompleted ? (
                          <>
                            <CheckCircle2 className="timeline-status-label-icon" />
                            Completado
                          </>
                        ) : (
                          <>
                            <Clock className="timeline-status-label-icon" />
                            Pendiente
                          </>
                        )}
                      </span>
                    </div>

                  {item.title == 'Cita Programada' && data.llegadaCliente?.fecha &&
                    <div className="timeline-arrival-info">
                      <div className="timeline-info-label">
                        <Calendar className="timeline-info-label-icon completed" />
                        <span className="timeline-info-label-text">Fecha de Llegada</span>
                      </div>
                      <div className="timeline-arrival-date">
                        {data.llegadaCliente.fecha} {data.llegadaCliente.hora}
                      </div>
                    </div>
                  }
                  </div>
                </div>

                {/* Conector entre elementos */}
                {!isLast && index !== 4 && (
                  <div className="timeline-connector">
                    {/* Línea horizontal superior */}
                    <div className={`timeline-connector-line ${nextItemCompleted ? 'completed' : 'pending'}`}></div>
                    
                    {/* Contenedor central con flecha y tiempo */}
                    <div className="timeline-connector-center">
                      <ArrowRight className={`timeline-connector-arrow ${nextItemCompleted ? 'completed' : 'pending'}`} />
                      
                      {/* Mostrar tiempo transcurrido */}
                      {(() => {
                        const timeDiff = calculateTimeDifference(item, timelineItems[index + 1]);
                        return timeDiff && (
                          <div className={`timeline-time-diff ${nextItemCompleted ? 'completed' : 'pending'}`}>
                            <Clock className="timeline-time-diff-icon" />
                            <span className="timeline-time-diff-text">{timeDiff}</span>
                          </div>
                        );
                      })()}
                    </div>
                    
                    {/* Línea horizontal inferior */}
                    <div className={`timeline-connector-line ${nextItemCompleted ? 'completed' : 'pending'}`}></div>
                  </div>
                )}
              </React.Fragment>
            );
          })}
        </div>
      </div>

      {/* Estadísticas finales */}
      <div className="timeline-stats">
        <div className="timeline-stats-grid">
          <div className="timeline-stat-item">
            <div className="timeline-stat-number total">{timelineItems.length -1}</div>
            <div className="timeline-stat-label">Total</div>
          </div>
          <div className="timeline-stat-item">
            <div className="timeline-stat-number completed">{completedItems}</div> 
            <div className="timeline-stat-label">Completados</div>
          </div>
          <div className="timeline-stat-item">
            <div className="timeline-stat-number pending">{timelineItems.length -1  - completedItems}</div>
            <div className="timeline-stat-label">Pendientes</div>
          </div>
          <div className="timeline-stat-item">
            <div className="timeline-stat-number progress">{Math.round(progressPercentage)}%</div>
            <div className="timeline-stat-label">Progreso</div>
          </div>
        </div>
      </div>

      {/* Instrucciones para móvil */}
      <div className="timeline-mobile-hint">
        <p className="timeline-mobile-hint-text">
          👆 Desliza horizontalmente para ver todos los pasos
        </p>
      </div>
    </div>
  );
};

// Ejemplo de uso


export default TimelineComponent;